import React from 'react';
import { Content } from 'src/styles/layout';
import { GridProps } from '@material-ui/core/Grid';
import { Item } from './styles';

export const CoverItem = ({ children, className, ...rest }: GridProps) => {
  return (
    <Content className={className}>
      <Item {...rest}>{children}</Item>
    </Content>
  );
};
